import React from "react";
import { AlertCircle } from "lucide-react";

interface ResponsiveWrapperProps {
  children: React.ReactNode;
}

const ResponsiveWrapper = ({ children }: ResponsiveWrapperProps) => {
  return (
    <div className="bg-[#0b0a07] min-h-screen">
      <div className="sm:hidden fixed inset-0 bg-[#0b0a07] z-[100] flex flex-col items-center justify-center p-6 text-center">
        <AlertCircle className="w-16 h-16 text-[#BBA473] mb-4" />
        <h2 className="text-2xl font-bold text-[#E8D5A3] mb-3">Better Experience Available</h2>
        <p className="text-[#8b8270] mb-6">
          For the best trading experience, please access this platform on a tablet, laptop, or desktop device.
        </p>
        <div className="p-4 bg-[#BBA473]/10 rounded-lg border border-[#BBA473]/30 max-w-sm">
          <p className="text-sm text-[#BBA473] mb-3">
            Your screen is too small for optimal trading. You cannot continue on a mobile screen; please use a larger device.
          </p>
          <a
            href="https://www.saveingold.app/"
            className="text-[#BBA473] underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit saveingold.app
          </a>
        </div>
      </div>
      <div className="h-full">{children}</div>
    </div>
  );
};

export default ResponsiveWrapper;
